// LoginPage.jsx

import { useTranslation } from 'react-i18next';
import LoginComponent from './LoginComponent';

function LoginPage() {
  const { t } = useTranslation();

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>{t('login', 'Log in')}</h1>
        <LoginComponent
          onSuccess={() => alert(t('confirmation_message', 'Login successful'))}
        />
      </div>
    </div>
  );
}

export default LoginPage;